import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("findlet_token") || null);
  const [loading, setLoading] = useState(true);

  // Verify current session
  const checkAuth = async () => {
    try {
      const storedToken = localStorage.getItem("findlet_token");
      if (!storedToken) {
        setLoading(false);
        setUser(null);
        return;
      }
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (err) {
      console.warn("Session check expired or not authenticated");
      setUser(null);
      setToken(null);
      localStorage.removeItem("findlet_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    if (res.data.token) {
      localStorage.setItem("findlet_token", res.data.token);
      setToken(res.data.token);
    }
    setUser(res.data);
    return res.data;
  };

  const register = async (userData) => {
    const res = await api.post("/auth/register", userData);
    if (res.data.token) {
      localStorage.setItem("findlet_token", res.data.token);
      setToken(res.data.token);
    }
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    setUser(null);
    setToken(null);
    localStorage.removeItem("findlet_token");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login,
        register,
        logout,
        checkAuth,
        isAuthenticated: !!user,
        role: user?.role || "guest"
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
